import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["srcset", "width", "height", "media"]
const _hoisted_2 = ["type", "srcset", "width", "height", "media"]
const _hoisted_3 = ["src", "alt", "width", "height", "loading", "fetch-priority"]

import { computed, ref } from "vue";
import { WebpHelper } from "@sazka/utils/webp-helper";
import { WebpImageExpose } from "../types/webp-image-reference";


export default /*@__PURE__*/_defineComponent({
  __name: 'webp-image',
  props: {
    src: {},
    cssClass: {},
    alt: {},
    width: {},
    height: {},
    isLazyload: { type: Boolean, default: false },
    loadingPriority: {},
    media: {},
    get2x: { type: Boolean, default: false },
    isInStorybook: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const rootRef = ref<HTMLPictureElement>();
__expose<WebpImageExpose>({
    rootRef,
});

const is2xEnabled = computed(() => props.get2x && !/@2x./.test(props.src));

const get2xSrc = (src: string): string => {
    // appends @2x to the end of the image name
    const srcUrl = new URL(src, window.location.origin);
    srcUrl.pathname = srcUrl.pathname.replace(".", "@2x.");
    return srcUrl.toString();
};

const getSrcset = (src1x: string, src2x: string): string => {
    return `${src1x} 1x, ${src2x} 2x`;
};

const imgSrcset = computed(() => {
    if (!props.src) {
        return "";
    }
    if (props.src.includes("|")) {
        const parts = props.src.split("|");
        return getSrcset(parts[0], parts[1]);
    }
    return is2xEnabled.value ? getSrcset(props.src, get2xSrc(props.src)) : props.src;
});

const webpSrcset = computed(() => {
    if (!props.src) {
        return "";
    }

    let src = props.src;

    //for images with saved width and height
    if (src.includes(";;")) {
        const parts = src.split(";;");
        src = parts[1];
    }

    const webpSrc = WebpHelper.webpUrl(src);

    if (webpSrc.includes("|")) {
        const parts = webpSrc.split("|");
        return getSrcset(parts[0], parts[1]);
    }

    return is2xEnabled.value ? getSrcset(webpSrc, get2xSrc(webpSrc)) : webpSrc;
});

const pattern = /(?:\.([^.]+))?$/;
const extension = pattern.exec(props.src || "")[1];

const mimeType = computed(() => {
    if (!extension) {
        return "";
    }

    return `image/${extension}`;
});

const displayWebp = computed(() => {
    return extension !== "svg";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("picture", {
    ref_key: "rootRef",
    ref: rootRef
  }, [
    (displayWebp.value && !_ctx.isInStorybook)
      ? (_openBlock(), _createElementBlock("source", {
          key: 0,
          type: "image/webp",
          srcset: webpSrcset.value,
          width: _ctx.width,
          height: _ctx.height,
          media: _ctx.media
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("source", {
      type: mimeType.value,
      srcset: imgSrcset.value,
      width: _ctx.width,
      height: _ctx.height,
      media: _ctx.media
    }, null, 8, _hoisted_2),
    _createElementVNode("img", {
      src: _ctx.src,
      alt: _ctx.alt,
      class: _normalizeClass(_ctx.cssClass),
      width: _ctx.width,
      height: _ctx.height,
      loading: _ctx.isLazyload ? 'lazy' : null,
      "fetch-priority": _ctx.loadingPriority
    }, null, 10, _hoisted_3)
  ], 512))
}
}

})